import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

interface ResolvedRow { user_id: string; email: string; source: string; }

const EMPTY: Record<string, string> = Object.freeze({});

export function useAuditEmails(userIds: string[]): Record<string, string> {
  const [map, setMap] = useState<Record<string, string>>(EMPTY);

  // Stable key for diffing — sorted unique uuids.
  const key = [...new Set(userIds)].sort().join(",");

  useEffect(() => {
    if (!key) return;
    let cancelled = false;
    (async () => {
      const ids = key.split(",");
      const { data, error } = await supabase.rpc("resolve_audit_emails", { p_user_ids: ids });
      if (cancelled) return;
      if (error || !data) {
        setMap(EMPTY);
        return;
      }
      const next: Record<string, string> = {};
      for (const row of data as ResolvedRow[]) {
        next[row.user_id] = row.email;
      }
      setMap(next);
    })();
    return () => { cancelled = true; };
  }, [key]);

  // When key is empty there is nothing to resolve — return the frozen empty
  // map directly without writing state. Avoids `setState` inside an effect
  // and keeps the hook idle when no uuids are passed.
  return key ? map : EMPTY;
}
